import styled, { css } from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const StyledCrmEnrichmentCard = styled.div`
    display: flex;
    position: relative;
    min-width: 333px;
    padding: 24px;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    border-radius: 6px;
    background: ${colorsPalettes.carbon[0]};

    box-shadow: 0px 3px 6px 0px rgba(14, 30, 62, 0.08);
`;

export const StyledEnrichmentImageWrapper = styled.div<{ isCrmAvailable?: boolean }>`
    display: flex;
    ${({ isCrmAvailable }) =>
        isCrmAvailable &&
        css`
            margin-top: 40px;
        `}
`;

export const StyledEnrichmentDescription = styled.div`
    display: flex;
    max-width: 333px;
    text-align: center;
    ${setFontVariant("body2", colorsPalettes.carbon[400])};
`;

export const StyledEnrichmentContactAdminText = styled(StyledEnrichmentDescription)`
    margin-top: 24px;
`;

export const StyledEnrichmentButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 24px;
`;

export const StyledButtonPlaceholderLoader = styled.div`
    svg {
        width: 100px;
        height: 36px;
    }
`;

export const StyledComingSoonLabelWrapper = styled.div`
    display: flex;
    position: absolute;
    left: 0;
    top: 24px;
`;
